import { $t } from '@/i18n';
import { defineComponent, inject } from '@vue/composition-api';
import { usePageletEvent, EVENTS } from '@composables/usePageletEvent';
import { DEFAULT_LESSCODE } from '@components/CodeEditor/utils/codes';
import styles from './index.module.scss';
const XyNavContainer = defineComponent({
    name: 'XyNavContainer',
    setup(props, { emit }) {
        usePageletEvent({ emit });
        const w = inject('w', null);
        const getDefaultSlot = () => {
            if (w?.mode === 'runtime')
                return null;
            return (<div class={styles.placeholder}>
        <span>{$t('k_e621cb4b')}</span>
      </div>);
        };
        return {
            getDefaultSlot,
        };
    },
    render() {
        return (<div class={['xy-nav-container', styles.container]}>
        {this.$slots.default || this.getDefaultSlot()}
      </div>);
    },
});
const componentId = 'xy-nav-container';
export const getDefaultNavConfig = (id) => ([
    {
        id,
        name: $t('k_a3aeb4a1'),
        layout: {
            type: componentId,
            props: {},
            children: [],
            style: {
                height: '56px',
                'background-color': 'rgba(255, 255, 255, 1)',
            },
        },
        xyType: 'pagelet',
        lessCode: DEFAULT_LESSCODE,
    },
]);
export default {
    component: XyNavContainer,
    componentForDesign: XyNavContainer,
    category: $t('k_96601653'),
    id: componentId,
    slots: [
        { id: 'default', selector: '.xy-nav-container' },
    ],
    events: EVENTS,
    display: 'block',
    visible: false,
    name: $t('k_6cf6f169'),
    propsSchema: {
        type: 'object',
        fields: [],
    },
    readme: '',
};
